// extracted by mini-css-extract-plugin
export var contentBody = "_41-9";
export var headerImage = "_41-2";
export var imageButton = "_41-7";
export var imageButtonIcon = "_41-8";
export var imageHeader = "_41-4";
export var imageHeaderText = "_41-5";
export var imageOverlay = "_41-3";
export var imageTitle = "_41-6";
export var imageWrapper = "_41-1";
export var taskList = "_41-a";
export var widget = "_41-0";